/* eslint-disable @typescript-eslint/use-unknown-in-catch-callback-variable -- for now */
/* eslint-disable @typescript-eslint/require-await -- for now */
/* eslint-disable @typescript-eslint/no-unsafe-type-assertion -- for now */
/* eslint-disable @typescript-eslint/no-unsafe-argument -- for now */
/* eslint-disable @typescript-eslint/no-explicit-any -- for now */
/* eslint-disable no-magic-numbers -- for now */
/* eslint-disable @typescript-eslint/no-unsafe-call -- for now  */
/* eslint-disable @typescript-eslint/strict-boolean-expressions -- for now  */
/* eslint-disable @typescript-eslint/no-unsafe-member-access -- for now */
/* eslint-disable @typescript-eslint/no-unsafe-assignment -- for now */

// src/services/libp2p/libp2p.service.impl.ts

import { createLibp2p } from 'libp2p';
import { webSockets } from '@libp2p/websockets';
import { noise } from '@chainsafe/libp2p-noise';
import { yamux } from '@chainsafe/libp2p-yamux';
import { identify } from '@libp2p/identify';
import { ping } from '@libp2p/ping';
import { floodsub } from '@libp2p/floodsub';
import { bootstrap } from '@libp2p/bootstrap';
import { inspectorMetrics } from '@ipshipyard/libp2p-inspector-metrics'
import { tcp } from '@libp2p/tcp';

import { P2P_CONFIG } from '@/config/p2pConfig';
import type { Libp2pService } from '@/services/abstract/poc/libp2p.service.interface';
import type { NodeOptions, LibP2pWithServices, ConnectionInfo } from '@/types/poc/libp2p';
import type { Logger } from '@/types/Logger';
import type { LoggerService } from '@/services/abstract/LoggerService';

/* -------------------------------------------------------------------------- */
/*  Pure Helper Functions                                                     */
/* -------------------------------------------------------------------------- */

function extractConnectionInfo(conn: any): ConnectionInfo {
  const addr = conn.remoteAddr.toString();
  const isDirect = addr.includes('/webrtc/') && !addr.includes('/p2p-circuit');
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- Need || for boolean OR, not ?? for nullish coalescing
  const isRelay = addr.includes('/p2p-circuit') || addr.includes('/ws/') || addr.includes('/wss/');

  return {
    peerId: conn.remotePeer.toString(),
    address: addr,
    isDirect,
    isRelay,
    direction: conn.direction
  };
}

/* -------------------------------------------------------------------------- */
/*  Implementation                                                            */
/* -------------------------------------------------------------------------- */

/**
 * Stateless implementation of the Libp2pService.
 * This class only handles LibP2P node creation and configuration.
 * All state management is delegated to the caller via callbacks.
 */
export class Libp2pServiceImpl implements Libp2pService {
  private readonly log: Logger;

  constructor(loggerService: LoggerService) {
    this.log = loggerService.createLogger({ namespace: 'six3ro:p2p:libp2p' });
  }

  /**
   * Creates a libp2p node with a comprehensive default configuration.
   * Sets up event listeners that invoke the provided callbacks.
   */
  async createNode(options: NodeOptions): Promise<LibP2pWithServices> {
    // Deduplicate and filter empty bootstrap peers from options
    const uniqueBootstrapPeers = [...new Set(options.bootstrapNodes)].filter(bp => bp !== '');
    this.log.info(`Bootstrap peers for six ${options.sixId}:`, uniqueBootstrapPeers);

    const callbacks = options.callbacks ?? {};

    // Build ICE servers from pre-generated credentials if TURN config is provided
    let iceServers: RTCIceServer[] = [];
    if (options.turnConfig) {
      iceServers = [{
        urls: options.turnConfig.urls,
        username: options.turnConfig.username,
        credential: options.turnConfig.credential
      }];
      this.log.info('Using pre-generated TURN credentials', {
        urls: options.turnConfig.urls,
        expiresAt: options.turnConfig.username
      });
    } else {
      this.log.warn('No TURN config provided, WebRTC may fail without ICE servers');
    }

    const config = {
      addresses: {
        listen: [],
        announce: []
      },
      transports: [
        webSockets(),
      ],
      connectionEncrypters: [noise()],
      streamMuxers: [yamux({
        maxInboundStreams: P2P_CONFIG.yamux.maxInboundStreams,
        maxOutboundStreams: P2P_CONFIG.yamux.maxOutboundStreams,
        enableKeepAlive: P2P_CONFIG.yamux.enableKeepAlive,
        keepAliveInterval: P2P_CONFIG.yamux.keepAliveInterval,
        clientStreamWindowSize: P2P_CONFIG.yamux.clientStreamWindowSize,
        maxStreamWindowSize: P2P_CONFIG.yamux.maxStreamWindowSize,
        streamOptions: {
          initialStreamWindowSize: P2P_CONFIG.yamux.initialStreamWindowSize,
          maxStreamWindowSize: P2P_CONFIG.yamux.maxStreamWindowSize,
          maxInboundStreams: P2P_CONFIG.yamux.maxInboundStreams,
          maxOutboundStreams: P2P_CONFIG.yamux.maxOutboundStreams,
        }
      } as any)],
      connectionGater: {
           denyDialMultiaddr: async() => false,
        // denyDialPeer: async(peerId: PeerId) => {
        //   // Block connections to our own peer IDs from this tab
        //   const peerIdStr = peerId.toString()
        //   if (this.localPeerIds.has(peerIdStr)) {
        //     this.log.debug(`[Group ${this.config.groupId}] Blocked connection to same-tab peer: ${peerIdStr}...`)
        //     return true
        //   }
        //   return false
        // }
      },
      connectionManager: {
        maxConnections: P2P_CONFIG.connectionManager.maxConnections,
        minConnections: P2P_CONFIG.connectionManager.minConnections,
        maxPeerAddrsToDial: P2P_CONFIG.connectionManager.maxPeerAddrsToDial,
        inboundConnectionThreshold: P2P_CONFIG.connectionManager.inboundConnectionThreshold,
        autoDialInterval: P2P_CONFIG.connectionManager.autoDialInterval,
        dialTimeout: P2P_CONFIG.connectionManager.dialTimeout
      },
      connectionMonitor: {
        enabled: false
      },
      services: {
        identify: identify(),
        ping: ping({
          timeout: P2P_CONFIG.ping.timeout
        }),
        pubsub: floodsub(),
        bootstrap: bootstrap({
          list: uniqueBootstrapPeers
        })
      }
    };

    const node = await createLibp2p(config);
    await node.start();
// Connection close debug handler - disabled to reduce log noise
// node.addEventListener('connection:close', (evt) => { ... });

    const peerId = node.peerId.toString();
    this.log.info(`Started with peer ID: ${peerId}...`, { groupId: options.sixId });
    this.log.info('🔄 DCUTR enabled - will automatically upgrade relay connections to WebRTC', { groupId: options.sixId });

    // Setup event listeners with callbacks
    this.setupEventListeners(node, options.sixId, callbacks, uniqueBootstrapPeers);

    return node;
  }

  /**
   * Setup all event listeners for the node, delegating to callbacks.
   */
  private setupEventListeners(
    node: LibP2pWithServices,
    sixId: string,
    callbacks: NonNullable<NodeOptions['callbacks']>,
    bootstrapNodes: string[]
  ): void {
    const relayAddresses = bootstrapNodes;

    // Connection open event
    node.addEventListener('connection:open', (evt) => {
      const connInfo = extractConnectionInfo(evt.detail);

      // Only log relay connections (critical for monitoring)
      if (connInfo.isRelay && connInfo.address.includes('12D3KooW')) {
        this.log.info(`✅ RELAY CONNECTION ESTABLISHED`);
        this.log.info(`   Relay: ${connInfo.peerId.substring(0, 20)}...`);
      }

      callbacks.onConnectionOpen?.(connInfo);
    });

    // Connection close event - minimal logging to reduce noise
    node.addEventListener('connection:close', (evt) => {
      const connInfo = extractConnectionInfo(evt.detail);
      this.log.debug(`Connection closed: ${connInfo.peerId.substring(0, 12)}...`);
      callbacks.onConnectionClose?.(connInfo);
    });

    // Peer connect event
    node.addEventListener('peer:connect', (evt) => {
      const peerId = evt.detail.toString();
      const connections = node.getConnections(evt.detail);

      // Reduced logging - only debug level
      this.log.debug(`Peer connected: ${peerId.substring(0, 20)}... (${connections.length} connections)`);

      const connectionInfos = connections.map(extractConnectionInfo);
      callbacks.onPeerConnect?.(peerId, connectionInfos);

      // Check if this is a bootstrap peer (HAP) - if so, re-announce subscriptions
      // This fixes the issue where GossipSub SUBSCRIBE messages don't reliably propagate
      const isBootstrapPeer = bootstrapNodes.some(addr => addr.includes(peerId));
      if (isBootstrapPeer) {
        this.log.info(`🔄 Connected to bootstrap peer (HAP): ${peerId.substring(0, 20)}...`);
        this.log.info(`   Will re-announce subscriptions after pubsub streams establish...`);

        // Delay to allow pubsub streams to be established
        const RESUBSCRIBE_DELAY_MS = 3000;
        setTimeout(() => {
          this.reannounceSubscriptions(node, peerId);
        }, RESUBSCRIBE_DELAY_MS);
      }
    });

    // Peer disconnect event - minimal logging
    node.addEventListener('peer:disconnect', (evt) => {
      const peerId = evt.detail.toString();
      this.log.debug(`Peer disconnected: ${peerId.substring(0, 12)}...`);
      callbacks.onPeerDisconnect?.(peerId);
    });

    // Peer discovery event
    node.addEventListener('peer:discovery', (evt) => {
      const discoveredPeer = evt.detail;
      const peerId = discoveredPeer.id.toString();
      const shortPeerId = peerId + '...';

      // Skip relay servers
      const isRelayServer = relayAddresses.some(addr => addr.includes(peerId));
      if (isRelayServer) {
        return;
      }

      // Skip self
      if (peerId === node.peerId.toString()) {
        return;
      }

      // Skip if already connected
      const existingConnection = node.getConnections(discoveredPeer.id);
      if (existingConnection.length > 0) {
        return;
      }

      // Attempt to dial
      this.log.debug(`🔍 Discovered peer ${shortPeerId}, attempting to dial...`);
      node.dial(discoveredPeer.id).then(() => {
        this.log.debug(`   ✅ Successfully dialed ${shortPeerId}`);
      }).catch((err) => {
        this.log.debug(`   ⚠️ Failed to dial ${shortPeerId}: ${err.message}`);
      });
    });

    // Subscription change event
    node.services.pubsub.addEventListener('subscription-change', (evt) => {
      const peerId = evt.detail.peerId.toString();
      const subscriptions = evt.detail.subscriptions.map((sub: any) => ({
        topic: sub.topic,
        subscribe: sub.subscribe
      }));

      callbacks.onSubscriptionChange?.(peerId, subscriptions);
    });

    // Global error handlers for stream errors
    const errorHandler = (event: ErrorEvent) => {
      const err = event.error;
      if (err && (err.name === 'StreamStateError' || (err.message?.includes('stream') && err.message?.includes('closed')))) {
        this.log.debug('🔇 Suppressed expected stream closure error:', err.message);
        event.preventDefault();
      }
    };

    const rejectionHandler = (event: PromiseRejectionEvent) => {
      const err = event.reason;
      if (err && (err.name === 'StreamStateError' || (err.message?.includes('stream') && err.message?.includes('closed')))) {
        this.log.debug('🔇 Suppressed expected stream rejection:', err.message);
        event.preventDefault();
      }
    };

    window.addEventListener('error', errorHandler);
    window.addEventListener('unhandledrejection', rejectionHandler);

    // Store handlers for cleanup
    (node as any).__errorHandler = errorHandler;
    (node as any).__rejectionHandler = rejectionHandler;
  }

  /**
   * Stop a specific libp2p node and clean up its resources.
   */
  async stopNode(node: LibP2pWithServices): Promise<void> {
    const peerId = node.peerId.toString();
    this.log.info(`🛑 Stopping LibP2P node: ${peerId}...`);

    // Remove global error handlers
    const errorHandler = (node as any).__errorHandler;
    const rejectionHandler = (node as any).__rejectionHandler;
    if (errorHandler) {
      window.removeEventListener('error', errorHandler);
    }
    if (rejectionHandler) {
      window.removeEventListener('unhandledrejection', rejectionHandler);
    }

    // Stop the node
    try {
      await node.stop();
      this.log.info(`✅ LibP2P node stopped: ${peerId}...`);
    } catch (error) {
      this.log.error(`Error stopping LibP2P node ${peerId}...:`, error);
      throw error;
    }
  }

  /**
   * Subscribe to a pub/sub topic.
   */
  subscribeToTopic(
    node: LibP2pWithServices,
    topic: string,
    handler: (message: Uint8Array) => void
  ): () => void {
    this.log.debug(`🔔 LibP2P subscribing to topic: ${topic}`);
    node.services.pubsub.subscribe(topic);

    const eventHandler = (evt: CustomEvent) => {
      if (evt.detail.topic === topic) {
        handler(evt.detail.data);
      }
    };

    node.services.pubsub.addEventListener('message', eventHandler as EventListener);

    return () => {
      this.log.debug(`🧹 Unsubscribing from topic: ${topic}`);
      node.services.pubsub.removeEventListener('message', eventHandler as EventListener);
      node.services.pubsub.unsubscribe(topic);
    };
  }

  /**
   * Publish a message to a pub/sub topic.
   */
  async publishToTopic(
    node: LibP2pWithServices,
    topic: string,
    data: Uint8Array | string
  ): Promise<void> {
    const messageData = typeof data === 'string'
      ? new TextEncoder().encode(data)
      : data;

    const peers = node.services.pubsub.getSubscribers(topic);

    // CRITICAL LOG: Show subscriber count when publishing to file list topic
    if (topic.includes('file-list')) {
      this.log.info(`📤 PUBLISHING to ${topic}`);
      this.log.info(`   Subscribers: ${peers.length} peer(s)`);
      if (peers.length > 0) {
        peers.forEach(p => {
          this.log.info(`   - ${p.toString().substring(0, 20)}...`);
        });
      } else {
        this.log.warn(`   ⚠️ NO SUBSCRIBERS - message will not be received`);
      }
    }

    try {
      await node.services.pubsub.publish(topic, messageData);
    } catch (err) {
      if (err.message?.includes('stream') && err.message?.includes('closed')) {
        this.log.warn(`⚠️ Stream closed while publishing to ${topic}, may need reconnection`);
      } else {
        this.log.error(`❌ Error publishing to topic ${topic}:`, err);
      }
      throw err;
    }
  }

  /**
   * Re-announce all current subscriptions to force GossipSub SUBSCRIBE messages.
   * This is needed because SUBSCRIBE control messages don't always propagate
   * reliably when a new connection is established.
   */
  private reannounceSubscriptions(node: LibP2pWithServices, targetPeerId: string): void {
    try {
      const pubsub = node.services.pubsub;
      const topics = pubsub.getTopics();

      if (topics.length === 0) {
        this.log.info(`🔄 No subscriptions to re-announce to ${targetPeerId.substring(0, 20)}...`);
        return;
      }

      this.log.info(`🔄 Re-announcing ${topics.length} subscription(s) to HAP ${targetPeerId.substring(0, 20)}...`);
      this.log.info(`   Topics: ${topics.join(', ')}`);

      // Unsubscribe and re-subscribe to each topic
      // This forces GossipSub to send fresh SUBSCRIBE control messages
      for (const topic of topics) {
        pubsub.unsubscribe(topic);
        pubsub.subscribe(topic);
        this.log.debug(`   ✓ Re-subscribed to: ${topic}`);
      }

      this.log.info(`✅ Re-announced all subscriptions to HAP`);

      // Log the subscriber state after re-announcement
      setTimeout(() => {
        for (const topic of topics) {
          const subscribers = pubsub.getSubscribers(topic);
          const hapSubscriber = subscribers.find(p => p.toString() === targetPeerId);
          this.log.info(`   📊 Topic '${topic}': ${subscribers.length} subscriber(s), HAP subscribed: ${hapSubscriber ? 'YES' : 'NO'}`);
        }
      }, 1000);
    } catch (err) {
      this.log.error(`❌ Error re-announcing subscriptions:`, err);
    }
  }
}
